import './models/cart/cart-state.js';
import './models/checkout/checkout-step-error-type.js';
import './models/checkout-settings.js';
import './models/step-shipping/shipping-methods.js';
import './models/shared.js';

var CustomerType;
(function(CustomerType) {
    CustomerType["Private"] = 'private';
    CustomerType["Company"] = 'company';
})(CustomerType || (CustomerType = {}));

export { CustomerType };
//# sourceMappingURL=types.js.map
